const environments = {
  local: {
    apiBaseUrl: 'http://localhost:8000/api',
    tiktokPixelId: 'CL1I6RJC77UA03IGSR10',
  },
  dev: {
    apiBaseUrl: 'https://dev.pixellapi.com/api',
    tiktokPixelId: 'CL1I6RJC77UA03IGSR10',
  },
  prod: {
    apiBaseUrl: 'https://prod.pixellapi.com/api',
    tiktokPixelId: 'CL1I6RJC77UA03IGSR10',
  },
};

const getEnvironment = () => {
  const env = process.env.REACT_APP_ENV || 'local';
  console.log('env', env);
  return environments[env as keyof typeof environments];
};

export const config = getEnvironment();
